module.exports = __webpack_public_path__ + "static/elm-bfd8d90506a151ab4f72c5a18ec64557.png";